import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { partnerQueryKeys } from "../api/queryKeys";
import { acceptPartnerTerms } from "../api/endpoints/me";

const errorMessage = (error) =>
  error?.response?.data?.errorMessage ||
  error?.response?.data?.message ||
  "Could not record your acceptance. Try again.";

/**
 * Records acceptance of the version in force. The answer is the fresh terms view, written straight
 * into the cache so the gate lifts at once; everything else the portal holds is refetched, since
 * calls made while the terms were outstanding were refused.
 */
const useAcceptPartnerTerms = () => {
  const queryClient = useQueryClient();
  return useMutation(acceptPartnerTerms, {
    onSuccess: (terms) => {
      toast.success("Terms accepted");
      if (terms) queryClient.setQueryData(partnerQueryKeys.terms(), terms);
      queryClient.invalidateQueries(partnerQueryKeys.all);
    },
    onError: (error) => toast.error(errorMessage(error)),
  });
};

export default useAcceptPartnerTerms;
